import {checkoutPayload, loadProfileToOrder} from "@/app/events/[id]/store/buy-tickets.store";
import React, {useEffect} from "react";
import {useSignals} from "@preact/signals-react/runtime";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import {CheckoutFormWithElement} from "@/app/events/[id]/components/CheckoutForm";
import {FreeCheckout} from "@/app/events/[id]/components/FreeCheckout";
import {whiteLabelStore} from "@/store/whitelabel.store";

export const PaymentDetails = () => {

    const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY || whiteLabelStore.value?.stripePublicKey || "");

    useSignals();
    useEffect(() => {
        loadProfileToOrder()
    }, []);

    const checkoutPayloadData = checkoutPayload.value
    return (
        <>
            {
                checkoutPayloadData && !checkoutPayloadData.isFreeCheckout ? (
                    <Elements stripe={stripePromise} options={{
                        mode: 'payment',
                        amount: checkoutPayloadData?.amount,
                        currency: checkoutPayloadData.currency,
                        appearance: {},
                        customerOptions: {
                            customer: checkoutPayloadData?.customerId,
                            ephemeralKey: checkoutPayloadData?.ephemeralKey ?? ""
                        }
                    }}>
                        <CheckoutFormWithElement/>

                    </Elements>
                ) : <FreeCheckout/>
            }

        </>
    )
}